import { commitMutation, Environment } from "react-relay";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import {
    CalculateBestRateInput,
    CalculateBestRateMutationResponse,
} from "@/Domains/BookingManagement/Booking/Shared/Mutations/__generated__/CalculateBestRateMutation.graphql";
import { BaseError } from "@/Utils/BaseError";

export default (
    input: CalculateBestRateInput,
    onCompleted: (error: Error | null, result?: any | null) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation CalculateBestRateMutation(
                $input: CalculateBestRateInput!
            ) {
                calculateBestRateMutation(input: $input) {
                    invoicePositionId
                    bookingId
                    position
                    rate
                    description
                    amount
                    unit
                    netSinglePrice
                    grossPrice
                    grossTotalPrice
                    includedDistance
                    discount
                }
            }
        `,
        variables: {
            input: input,
        },
        onCompleted(result) {
            const res = result as CalculateBestRateMutationResponse;
            const invoicePositions = res.calculateBestRateMutation;

            if (invoicePositions) {
                onCompleted(null, invoicePositions);
                return;
            }

            throw new BaseError(
                "CalculateBestRateMutation failed with an unexpected Error",
                {
                    context: {
                        // TODO
                    },
                },
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
